export default "/assets/images/tech_page_02.e5e074edcb899fd9.mp4";